import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ControlContainer, FormGroupDirective, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { AbstractControlToFormControlPipe } from '../../../pipes/abstract-control-to-form-control.pipe';

@Component({
  selector: 'shared-checkbox',
  imports: [ReactiveFormsModule, Checkbox, AbstractControlToFormControlPipe],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class CheckboxComponent {
  public ngControl = inject(NgControl, { optional: true, self: true });

  readonly inputId = input('');
  readonly label = input('');
  readonly binary = input(false);

  readonly checkedChange = output<boolean>();

  constructor() {
    if (this.ngControl) {
      // trick it into thinking control has a valueAccessor, we don't need it because child has
      this.ngControl.valueAccessor = {
        writeValue(): void {
          // do nothing
        },
        registerOnChange(): void {
          // do nothing
        },
        registerOnTouched(): void {
          // do nothing
        },
      };
    }
  }
}
